/**
 * AI-generated code, moderated by Lukasz Zygmanski
 */
export const fallbackLanguage = 'en';

export const supportedLanguages = ['pl', 'en', 'de', 'uk'] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export function isSupportedLanguage(
  language: string
): language is SupportedLanguage {
  return supportedLanguages.includes(language as SupportedLanguage);
}
